import { render, staticRenderFns } from "./BtnAtras.vue?vue&type=template&id=0e9551a2&"
import script from "./BtnAtras.vue?vue&type=script&lang=js&"
export * from "./BtnAtras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports